import { observe } from './observe'
import { computed } from './computed'
import { dispose } from './dispose'

export default {
    observe,
    computed,
    dispose
}
